
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/claims-compliance/catastrophe-claims-guide",
      function () {
        return require("private-next-pages/compliance/claims-compliance/catastrophe-claims-guide.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/claims-compliance/catastrophe-claims-guide"])
      });
    }
  